
// const company = 'companies(c195304b-23ed-4677-a92c-90c7a93fe908)'
const companyId = localStorage.getItem('companyId');
// const company = `companies(27e5e45e-4480-42d7-9901-305d62e14a44)`
const company = `companies(${companyId})`
const baseUrl = process.env.REACT_APP_COMMON_API_URL + company
const getMovement = baseUrl + '/movements'
const getPartialTrip = baseUrl + '/partialTrips'
const DeleteDepot = baseUrl + '/deleteDepots?' + '&$expand=movementlines,operationDetail'
const DeleteHookOff = baseUrl + '/deleteHookOff?' + '&$expand=movementlines,operationDetail'
const InsertDepots = baseUrl + '/insertDepots?' + '$expand=movementlines,operationDetail'
const InsertTerminals = baseUrl + '/insertTerminals?' + '$expand=movementlines,operationDetail'
const DeleteTerminals = baseUrl + '/deleteTerminals?' + '$expand=movementlines,operationDetail'
const ChangePlanDepartment = baseUrl + '/changePlanDepartmentMovements?' + '$expand=movementlines,operationDetail'
const ChangePlanSubdepartment = baseUrl + '/changePlanSubdepartmentMovements?' + '$expand=movementlines,operationDetail'
const getDepot = baseUrl + '/transportAddresses'
const getPostalCode = baseUrl + '/postCodes';
const getProblemCodes = baseUrl + '/problemCodes';
const getDepartments = baseUrl + '/departments';
const getSubdepartments = baseUrl + '/subdepartments';
const getShipmentActions = baseUrl + '/shipmentActions';
const customHookoff = baseUrl + '/customHookOff?' + '$expand=movementlines,operationDetail'
const insertHookOff = baseUrl + '/hookOff?' + '$expand=movementlines,operationDetail'
const postContractout = baseUrl + '/contractOutMovements?' + '$expand=movementlines,contractoutaction'
const planMovements = baseUrl + '/planMovements?' + '$expand=movementlines,action'
const planMovementsNew = baseUrl + '/planMovementsNew?' + '$expand=movementlines,operationDetail'
const createTrips = baseUrl + '/createTrips?' + '$expand=movementlines,operationDetail'
const postponeMovements = baseUrl + '/postponeMovements?' + '$expand=movementlines,operationDetail'
const getSubcontractors = baseUrl + '/subcontractors'
const getTrailers = baseUrl + '/trailers'
const getDrivers = baseUrl + '/drivers'
const getVehicles = baseUrl + '/vehicles'
const getVariousResources = baseUrl + '/variousResources'
const getRoutes = baseUrl + '/routes'
const getShipmentMov = baseUrl + '/ptmovements'
const fetchSavedView = baseUrl + '/savedViews'
const postSavedView = baseUrl + '/savedViews'
const routeGidesdata = baseUrl + '/routeGuides'
const postSetfree = baseUrl + '/setFree?' + '$expand=movementlines,operationDetail'
const postSetFreeRoutes = baseUrl + '/setFreeRoutes?' + '$expand=routelines,operationDetail';
const fetchStatuseData = baseUrl + '/statuses'
const getCustomActions = baseUrl + "/customActions"
const movementCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'movement'"
const driverCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'driver'"
const partialTripCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'partialTrip'"
const ptmovementCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'ptmovement'"
const subcontractorMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'subcontractor'"
const trailerCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'trailer'"
const variousResourcesCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'variousResources'"
const vehicleCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'vehicle'"
const dashboardCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq"
const routeCaptionMetaData = process.env.REACT_APP_COMMON_API_URL + "entityDefinitions?$filter=entityName eq 'route'"
const postProcesstrips = baseUrl + '/processTripsForMovements?' + '$expand=movementlines,operationDetail';
const postCreateSeparateBookings = baseUrl + '/createSeparateBookings?' + '$expand=movementlines,operationDetail';
const postCreateOrAddToExistingBookings = baseUrl + '/createOrAddToExistingBookings?' + '$expand=movementlines,operationDetail';
const postChangesStatus = baseUrl + '/changeStatusPartialTrips?' + '$expand=partialtriplines,operationDetail';
const postExecuteCustomActionMovements = baseUrl + '/executeCustomActionMovements?' + '$expand=movementlines,operationDetail';
const postExecuteCustomActionPartialTrips = baseUrl + '/executeCustomActionPartialTrips?' + '$expand=partialtriplines,operationDetail';
const actionCode = baseUrl + '/actionCodes'
const filterableColumn = 'setup(bf40dedf-d006-ef11-a149-002248843480)/ColumnsMetadata'
const logoutUrl = 'https://login.microsoftonline.com/common/oauth2/logout'
const planGroups = baseUrl + '/planGroups'
const vehiclePlanning = baseUrl + '/vehiclePlanning'
const trailerPlanning = baseUrl + '/trailerPlanning'
const driverPlanning = baseUrl + '/driverPlanning'
const chassisPlanning = baseUrl + '/chassisPlanning'
const variousPlanning = baseUrl + '/variousPlanning'
const planGroupResources = baseUrl + '/planGroupResources'
const plannedActions = baseUrl + '/plannedActions'
const agendaCodes = baseUrl + '/agendaCodes'
const routes = baseUrl + '/routes'
const getLinkedRoutes = baseUrl + '/getLinkedRoutes'
const batchUrl = process.env.REACT_APP_COMMON_API_URL + '$batch'
const NVT = 'Microsoft.NAV.'
const ApiConst = {
    changePtResource:NVT+'changePtResource',
    getTooltipPersonalization:NVT+'getTooltipPersonalization'
};

export {
  getMovement,
  getPartialTrip,
  DeleteDepot,
  DeleteHookOff,
  InsertDepots,
  InsertTerminals,
  DeleteTerminals,
  getDepot,
  getProblemCodes,
  ChangePlanDepartment,
  getDepartments,
  ChangePlanSubdepartment,
  getSubdepartments,
  getShipmentActions,
  customHookoff,
  insertHookOff,
  postContractout,
  company,
  baseUrl,
  planMovements,
  planMovementsNew,
  createTrips,
  postponeMovements,
  getSubcontractors,
  getTrailers,
  getDrivers,
  getVehicles,
  getVariousResources,
  getRoutes,
  getShipmentMov,
  fetchSavedView,
  postSavedView,
  postSetfree,
  postSetFreeRoutes,
  driverCaptionMetaData,
  fetchStatuseData,
  partialTripCaptionMetaData,
  ptmovementCaptionMetaData,
  subcontractorMetaData,
  trailerCaptionMetaData,
  variousResourcesCaptionMetaData,
  vehicleCaptionMetaData,
  movementCaptionMetaData,
  dashboardCaptionMetaData,
  routeCaptionMetaData,
  postProcesstrips,
  postCreateSeparateBookings,
  postCreateOrAddToExistingBookings,
  postChangesStatus,
  routeGidesdata,
  logoutUrl,
  actionCode,
  filterableColumn,
  getPostalCode,
  getCustomActions,
  postExecuteCustomActionMovements,
  postExecuteCustomActionPartialTrips,
  planGroups,
  variousPlanning,
  chassisPlanning,
  driverPlanning,
  trailerPlanning,
  vehiclePlanning,
  planGroupResources,
  plannedActions,
  agendaCodes,
  routes,
  getLinkedRoutes,
  ApiConst,
  batchUrl
};
